export enum EProjectFileType {
  TWC_GE_REQUEST = 'ATW',
  CONSTRUCTION_REMOVAL_CERT = 'C',
  T2_ATTACHMENT = 'D',
  T3_DESIGNER = 'M',
  T3_DESIGNER_CALCULATION = 'MC',
  T3_SITE_OPERATION = 'S',
  T3_ICE = 'I',
  MISCELLANEOUS_FILE = 'O',
  DAILY_DESIGN_BRIEF = '2',
  DAILY_MODIFICATION_REQUEST = '3',
  DESIGN_CHECK_CERT = 'DCC',
  CONSTRUCTION_CHECK_CERT = 'CCC',
  CLIENT_CONSTRUCTION_CHECK_CERT = 'CCCC',
  CLIENT_DESIGN_CHECK_CERT = 'CDCC',
  LIST_OF_APPROVED_TWC = 'LAT',
  DESIGNER_TRANSMITTAL_SUPPLEMANTARY = 'DGT',
  DESIGNER_TRANSMITTAL_DRAWING = 'DTA',
  SITE_TRANSMITTAL_SUPPLEMANTARY = 'STT',
  SITE_TRANSMITTAL_DRAWING = 'STA',
  CHECKER_TRANSMITTAL_SUPPLEMANTARY = 'ICTT',
  LAMBETH_REVIEWER_RESPONSE_ATTACHMENT = 'LIRR',
  DAILY_SUMMARY_REPORT = 'DS',
  T1_SUPPLEMENTARY = 'T1TXT',
  T2_SUPPLEMENTARY = 'TXT',
  REVIEWER_TRANSMITTAL_SUPPLEMANTARY = 'REVIT',
  T5_ATTACHMENTS = 'T5',
  T4_OTHER_REFERENCE_DOC = 'T4R',
  T4_REMOVE_REFERENCE_DOC = 'T4RR',
  T4_LOCALTION_PLAN = 'T4LP',
  T5_S_ATTACHMENTS = 'T5S',
  T4_CHECKLIST = 'T4CL',

  // Discussion Attachment Types
  DESIGN_BRIEF_DISCUSSION_ATTACHMENT = 'DBDA',
  DESIGN_MODIFICATION_DISCUSSION_ATTACHMENT = 'DMDA',
  DESIGN_MODIFICATION_ICE_DISCUSSION_ATTACHMENT = 'DMIDA',
  DESIGN_MODIFICATION_REVIEWER_DISCUSSION_ATTACHMENT = 'DMRDA',
  LOADING_REMOVAL_CERT_DISCUSSION_ATTACHMENT = 'LRCDA',
  TRANSMITTAL_DISCUSSION_ATTACHMENT = 'TDA',
  LAMBETH_REVIEWER_RESPONSE_DISCUSSION_ATTACHMENT = 'LRRDA',
}
